import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import toast from "react-hot-toast";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      toast.error(err.response?.data?.message || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    React.createElement("div", {
      style: {
        minHeight: "100vh", display: "flex", alignItems: "center",
        justifyContent: "center", background: "var(--bg)"
      }
    },
      React.createElement("div", { style: { width: "100%", maxWidth: 360, padding: "0 20px" } },
        React.createElement("div", { style: { textAlign: "center", marginBottom: 28 } },
          React.createElement("div", {
            style: {
              width: 40, height: 40, background: "var(--accent)", borderRadius: "var(--r)",
              display: "flex", alignItems: "center", justifyContent: "center",
              color: "#fff", fontSize: 20, fontWeight: 700, margin: "0 auto 14px"
            }
          }, "X"),
          React.createElement("div", { style: { fontSize: 18, fontWeight: 700, color: "var(--text-1)" } }, "Xion Console"),
          React.createElement("div", { style: { fontSize: 13, color: "var(--text-3)", marginTop: 4 } }, "Sign in to continue")
        ),
        React.createElement("div", { className: "card", style: { padding: 24 } },
          React.createElement("form", { onSubmit: handleSubmit },
            React.createElement("div", { className: "form-group" },
              React.createElement("label", null, "Email"),
              React.createElement("input", {
                type: "email", value: email,
                onChange: function(e) { setEmail(e.target.value); },
                placeholder: "you@company.com", required: true, autoFocus: true
              })
            ),
            React.createElement("div", { className: "form-group", style: { marginBottom: 20 } },
              React.createElement("label", null, "Password"),
              React.createElement("input", {
                type: "password", value: password,
                onChange: function(e) { setPassword(e.target.value); },
                placeholder: "Enter your password", required: true
              })
            ),
            React.createElement("button", {
              className: "btn btn-primary",
              type: "submit",
              disabled: loading,
              style: { width: "100%", padding: "9px", fontSize: 14 }
            }, loading ? "Signing in..." : "Sign in")
          )
        )
      )
    )
  );
}